module.exports = __webpack_public_path__ + "static/background-7816db9d030e68323e752ce8ca96b849.png";